import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import { IContentfulCollection } from '../../../types/ContentfulCollectionService.types'
import ImageSubCategoryList from '../imageSubCategoryList'
import { LinkGroupProps } from '../SubCategoryList'
import subCategoryListStyles from '../subCategoryList.module.scss'
import TextSubCategoryList from '../textSubCategoryList'

export interface SubCategoryLinksListProps {
  // buttonGroup: Omit<ButtonGroupProps, 'sendEventOnButtonClick'>
  linkGroup: LinkGroupProps
  contentful_id: string
  isNewCLPFiltersExperimentActive: boolean
  showLoader?: boolean
}

const SubCategoryLinksList = ({
  linkGroup,
  contentful_id,
  isNewCLPFiltersExperimentActive,
  showLoader,
}: SubCategoryLinksListProps) => {
  const sendEventOnButtonClick = (filterUsed: string, buttons: IContentfulCollection[]): void => {
    trackEvent(TELEMETRY_EVENT_NAMES.SIMILAR_COLLECTION_CLICKED, {
      filter_count: buttons.length || 0,
      filter_used: filterUsed,
      filter_available: buttons.map(button => button.name),
    })
  }
  return (
    <>
      <ImageSubCategoryList
        {...linkGroup}
        sendEventOnButtonClick={sendEventOnButtonClick}
        className={subCategoryListStyles.imageSubCategory}
        contentful_id={contentful_id}
        isNewCLPFiltersExperimentActive={isNewCLPFiltersExperimentActive}
        showLoader={showLoader}
      />
      <TextSubCategoryList
        {...linkGroup}
        sendEventOnButtonClick={sendEventOnButtonClick}
        className={subCategoryListStyles.textSubCategory}
        contentful_id={contentful_id}
        isNewCLPFiltersExperimentActive={isNewCLPFiltersExperimentActive}
        showLoader={showLoader}
      />
      {/* <ButtonGroup
        {...buttonGroup}
        sendEventOnButtonClick={sendEventOnButtonClick}
        className={subCategoryListStyles.container__buttons}
      /> */}
    </>
  )
}

export default SubCategoryLinksList
